/**
 * Rate Plan Vuex Module
 *
 * 2025-12-26: Fixed error handling to properly propagate API errors to components
 *             instead of swallowing them with .catch(console.error)
 */
import customAxios from '@/axios/config'

export default {
  namespaced: true,
  state: {
    ratePlans: [],
    availableListings: [],
  },
  mutations: {
    updateRatePlans(state, payload) {
      state.ratePlans = payload.data.rate_plans
    },
    updateAvailableListings(state, payload) {
      state.availableListings = payload
    },
  },
  actions: {
    async getRatePlans({ commit }, params) {
      try {
        const { data } = await customAxios.get('api/rate-plans', {
          params: {
            include_listings: params?.include_listings,
            listing_id: params?.listing_id,
          },
        })

        commit('updateRatePlans', data.payload)
        return data
      } catch (error) {
        console.error('Error fetching rate plans:', error)
        throw error
      }
    },

    async getAvailableListings({ commit }) {
      try {
        const { data } = await customAxios.get('api/listings-picker')
        commit('updateAvailableListings', data)
        return data
      } catch (error) {
        console.error('Error fetching available listings:', error)
        throw error
      }
    },

    async createRatePlan({ dispatch }, payload) {
      const response = await customAxios.post('api/rate-plans', payload)

      // Check if API returned an error in the response body
      if (response.data && !response.data.success) {
        const errorMessage =
          response.data.payload?.data?.error ||
          response.data.error ||
          'Failed to create rate plan'
        throw new Error(errorMessage)
      }

      await dispatch('getRatePlans', {
        include_listings: true,
      })

      return response.data
    },

    async updateRatePlan({ dispatch }, { id, ...payload }) {
      const response = await customAxios.put('api/rate-plans/' + id, payload)

      // Check if API returned an error in the response body
      if (response.data && !response.data.success) {
        const errorMessage =
          response.data.payload?.data?.error ||
          response.data.error ||
          'Failed to update rate plan'
        throw new Error(errorMessage)
      }

      await dispatch('getRatePlans', {
        include_listings: true,
      })

      return response.data
    },

    async deleteRatePlan({ dispatch }, payload) {
      const { id } = payload
      const response = await customAxios.delete('api/rate-plans/' + id)

      // Check if API returned an error in the response body
      if (response.data && !response.data.success) {
        const errorMessage =
          response.data.payload?.data?.error ||
          response.data.error ||
          'Failed to delete rate plan'
        throw new Error(errorMessage)
      }

      await dispatch('getRatePlans', {
        include_listings: true,
      })

      return response.data
    },
  },
}
